import { render, staticRenderFns } from "./PrivacyPolicyPage.vue?vue&type=template&id=1d58c5f8&scoped=true"
import script from "./PrivacyPolicyPage.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyPage.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyPage.vue?vue&type=style&index=0&id=1d58c5f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d58c5f8",
  null
  
)

export default component.exports